import { useState } from "react";
import {
    Input,
  } from "../../../../components/react-hook-form";

function InputWithInitialValue({ initialValue, name, defaultValue, disabled, rules, setV}) {
    const [value, setValue] = useState(defaultValue);
    const [clicked, setClicked] = useState(false);
  
    const handleClick = () => {
      if (!clicked && !value && initialValue) {
        setClicked(true);
        setValue(initialValue);
        setV(name, initialValue)
      }
    };
  
    const handleChange = (event) => {
      setValue(event.target.value);
      setV(name, event.target.value);
    };
  
    const handleBlur = (event) => { 
        setClicked(false)
     }

    return (
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        onClick={handleClick}
        onBlur={handleBlur}
        rules={rules}
        className="form-control form-control-sm"
        name={name}
        defaultValue={defaultValue}
        style={{ width: 200, backgroundColor: '#F4F7FE' }}
        disabled={disabled}
/>
    );
  }
export default InputWithInitialValue